import React from 'react';
import Main from './components/404/Main';

const NotFound = () => {
    return (
        <div>
            <Main />
        </div>
    )
}

export default NotFound;